import { AppStructureBuilderError } from './error';
export function addComment({ comment, viewName, scopeName }) {
    this.updateAppStructure(draftBuilder => {
        const view = draftBuilder.getView(viewName);
        const scope = scopeName ? view?.scopes[scopeName] : undefined;
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (scopeName && !scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (scope) {
            scope.comments = scope.comments || [];
            scope.comments.push(comment);
        }
        else {
            view.comments = view.comments || [];
            view.comments.push(comment);
        }
    });
    return this;
}
export function removeComment({ order, viewName, scopeName }) {
    this.updateAppStructure(draftBuilder => {
        const view = draftBuilder.getView(viewName);
        const scope = scopeName ? view?.scopes[scopeName] : undefined;
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (scopeName && !scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (scope) {
            if (!scope.comments) {
                throw new AppStructureBuilderError(`Scope ${scopeName} has no comments`);
            }
            scope.comments.splice(order, 1);
        }
        else {
            if (!view.comments) {
                throw new AppStructureBuilderError(`View ${viewName} has no comments`);
            }
            view.comments.splice(order, 1);
        }
    });
    return this;
}
export function updateComment({ order, comment, viewName, scopeName }) {
    this.updateAppStructure(draftBuilder => {
        const view = draftBuilder.getView(viewName);
        const scope = scopeName ? view?.scopes[scopeName] : undefined;
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (scopeName && !scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (scope) {
            if (!scope.comments) {
                throw new AppStructureBuilderError(`Scope ${scopeName} has no comments`);
            }
            scope.comments[order] = comment;
        }
        else {
            if (!view.comments) {
                throw new AppStructureBuilderError(`View ${viewName} has no comments`);
            }
            view.comments[order] = comment;
        }
    });
    return this;
}
//# sourceMappingURL=commentManagement.js.map